import { useState } from "react";
import { useParams } from "react-router-dom";
import CommonCertificateNotesForm from "../../../../components/common/CertificateNotesGrid/CertificateNotesGrid";
import {
  useDeleteCertificateNoteByIdMutation,
  useGetCertificateNotesByReferenceIdQuery
} from "../../../../components/common/CertificateNotesGrid/CertificateNotesApi";
import CertNoteAddOrUpdateModal from "../../../../components/common/CertificateNotesGrid/CertNoteAddOrUpdateModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";


const ThirdPartyProviderCertificateNotesForm = () => {
  const { providerId } = useParams();
  const [showCertUpdateModel, setShowCertUpdateModel] = useState(false);
  const [showManagementCertificateModal, setShowManagementCertificateModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [certificateNoteId, setCertificateNoteId] = useState(null);
  const [noteObject, setNoteObject] = useState(null);
  const [deleteNotesApi, { isLoading }] = useDeleteCertificateNoteByIdMutation();
  const {
    data: certificateNotes,
    isLoading: loading,
    isError: error,
  } = useGetCertificateNotesByReferenceIdQuery(providerId || "");



  const handleDeleteCertificateNotes = async (e: any) => {
    e.preventDefault();
    if (certificateNoteId !== null && certificateNoteId !== '') {
      try {
        await deleteNotesApi(certificateNoteId);
        setShowDeleteConfirm(false);
      } catch (error) {
        console.error('Error deleting certificate note:', error);
      }
    }
  };


  return (

    <div className={"mt-3"}>
      <CommonCertificateNotesForm
        title={"Third Party Provider Certificate Notes"}
        data={certificateNotes}
        relationalId={providerId}
        count={certificateNotes?.length || 0}
        setShowAddNoteModal={setShowManagementCertificateModal}
        setNoteObject={setNoteObject}
        setShowNoteUpdateModel={setShowCertUpdateModel}
        setNoteId={setCertificateNoteId}
        setShowDeleteConfirm={setShowDeleteConfirm}
      />

      {
        showManagementCertificateModal &&
        <CertNoteAddOrUpdateModal title={"Add Third Party Provider Certificate Note"}
          show={showManagementCertificateModal}
          setShow={setShowManagementCertificateModal}
          relationalId={providerId}
          type={"ThirdParty"}
          length={certificateNotes && certificateNotes.length + 1}
          btnName="Add" />
      }


      {showCertificateModal &&
        <CertNoteAddOrUpdateModal title={"Add Third Party Provider Certificate Note"} show={showCertificateModal}
          setShow={setShowCertificateModal} relationalId={providerId}
          type={"ThirdParty"}
          length={certificateNotes && certificateNotes.length + 1}
          btnName="Add" />}


      {showCertUpdateModel &&
        <CertNoteAddOrUpdateModal title={"Update Third Party Provider Certificate Note"}
          show={showCertUpdateModel}
          setShow={setShowCertUpdateModel}
          noteObj={noteObject}
          relationalId={providerId}
          btnName={"Update"} type={"ThirdParty"}

        />
      }
      {showDeleteConfirm && <ConfirmationModal title={"Delete Third Party Provider Certificate Note"}
        bodyMessage={"Are you sure you want to delete this certificate note?"}
        onSubmit={handleDeleteCertificateNotes}
        show={showDeleteConfirm}
        setShow={setShowDeleteConfirm}
        isLoading={isLoading}
      />
      }
    </div>
  );
};

export default ThirdPartyProviderCertificateNotesForm;